import { Component, OnInit,ViewChild } from '@angular/core';
import  {SERVICES } from '../../config/webservices';
import  {MESSAGES } from '../../config/messages';
import { ServicesProvider } from '../../providers/services';
//import * as M from "materialize-css/dist/js/materialize";
//import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
 
  constructor(

      public ServicesProvider:ServicesProvider/*,
      private route: ActivatedRoute*/

    ) { }

  ngOnInit() {

  }

 
}